import { Box, Stack } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import DeleteAlert from "../../../components/Alert/DeleteAlert";
import AppLoader from "../../../components/AppLoader";
import PaperContainer from "../../../components/Containers/PaperContainer";
import GlobalButton from "../../../components/CustomButton";
import AddEditRollDialog from "../../../components/Dialogs/AddEditRollDialog";
import GlobalTable from "../../../components/Tables/GlobalTable";
import { deleteAdminRole, getAllAdminRole } from "../../../services/roleApiFn";
import { handleOpenSnackBar } from "../../../utils";
import { t } from "i18next";
import { useTranslation } from "react-i18next";

const headerData = ["role", "assignedPages", "actions"];

const tableRows = ["role_name", "assigned_pages", "actions"];

function AllRolls() {
  const openDialog = useRef();
  const openDeleteDialog = useRef(null);
  const [allRole, setAllRole] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation(["setting", "common"]);


  useEffect(() => {
    fetchAllAdminRole();
  }, []);

  const fetchAllAdminRole = async () => {
    try {
      setIsLoading(true);
      const response = await getAllAdminRole();
      if (response.data.status === "success") {
        const data = response.data.data;
        setAllRole(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditRole = (row, ind) => {
    openDialog.current.openDialog({
      type: "edit",
      data: row,
      getData: fetchAllAdminRole,
    });
  };

  const handleOpenDeleteDialog = (params) => {
    openDeleteDialog.current.openDialog({
      data: params.row,
      warningText: t("deleteRoleConfirmation"),
    });
  };

  const handleDelete = async (params) => {
    try {
      setIsLoading(true);
      const response = await deleteAdminRole(params.data._id);
      if (response.data.status) {
        openDeleteDialog.current.closeDialog();
        fetchAllAdminRole();
        handleOpenSnackBar("success", response.data.message);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const renderHeaderActions = () => {
    return (
      <Stack
        gap={2}
        flex={1}
        direction={"row"}
        alignItems={"center"}
        justifyContent={"flex-end"}
      >
        <Box height={40}>
          <GlobalButton
            variant={"contained"}
            btnText={"createRoles"}
            styleProps={{ fontWeight: 400, width: "auto" }}
            handleClickBtn={() =>
              openDialog.current.openDialog({
                type: "add",
                data: null,
                getData: fetchAllAdminRole,
              })
            }
          />
        </Box>
      </Stack>
    );
  };
  return (
    <>
      <AppLoader isVisible={isLoading} />
      <PaperContainer
        title={t("createRoles")}
        subtitle={t("rolesManagementInfo")}
        headerActions={renderHeaderActions()}
      >
        <GlobalTable
          tableHeader={headerData}
          displayRows={tableRows}
          tableData={allRole}
          showActions={true}
          showEdit={true}
          handleEdit={handleEditRole}
          showDelete={true}
          handleDelete={handleOpenDeleteDialog}
        />
      </PaperContainer>
      <AddEditRollDialog ref={openDialog} />
      <DeleteAlert ref={openDeleteDialog} handleDelete={handleDelete} />
    </>
  );
}

export default AllRolls;
